/* eslint-disable */
// src\components\common\buttonStyles.js


const blue = {
  main: "#1976d2",
  dark: "#115293",
  border: "#1565c0",
  soft: "rgba(25, 118, 210, 0.08)",
};

const red = {
  main: "#c62828",
  dark: "#8e1b1b",
  border: "#b71c1c",
  soft: "rgba(198, 40, 40, 0.08)",
};

const green = {
  main: "#2e7d32",
  dark: "#1b5e20",
};

export const disabledButtonSx = {
  "&.Mui-disabled": {
    backgroundColor: "#e5e7eb",
    borderColor: "#9ca3af",
    color: "#4b5563",
    WebkitTextFillColor: "#4b5563",
    opacity: 1,
  },
};

export const secondaryOutlinedButtonSx = {
  color: blue.border,
  borderColor: blue.border,
  backgroundColor: "#fff",
  fontWeight: 700,
  "&:hover": {
    color: blue.dark,
    borderColor: blue.dark,
    backgroundColor: blue.soft,
  },
  ...disabledButtonSx,
};

export const filterApplyButtonSx = {
  color: "#fff",
  backgroundColor: blue.main,
  fontWeight: 700,
  "&:hover": {
    color: "#fff",
    backgroundColor: blue.dark,
  },
  ...disabledButtonSx,
};

export const filterClearButtonSx = {
  ...secondaryOutlinedButtonSx,
};

export const paginationContainedButtonSx = {
  ...filterApplyButtonSx,
};

export const debugTextButtonSx = {
  color: blue.border,
  fontWeight: 700,
  textTransform: "none",
  "&:hover": {
    color: blue.dark,
    backgroundColor: blue.soft,
  },
  ...disabledButtonSx,
};

export const dangerOutlinedButtonSx = {
  color: red.main,
  borderColor: red.border,
  backgroundColor: "#fff",
  fontWeight: 700,
  "&:hover": {
    color: red.dark,
    borderColor: red.dark,
    backgroundColor: red.soft,
  },
  ...disabledButtonSx,
};

export const dangerContainedButtonSx = {
  color: "#fff",
  backgroundColor: red.main,
  fontWeight: 700,
  "&:hover, &:focus:not(:hover)": {
    color: "#fff",
    backgroundColor: red.dark,
  },
  ...disabledButtonSx,
};

export const successContainedButtonSx = {
  color: "#fff",
  backgroundColor: green.main,
  fontWeight: 700,
  "&:hover": {
    color: "#fff",
    backgroundColor: green.dark,
  },
  ...disabledButtonSx,
};

export const deviceActionButtonSx = {
  minHeight: 32,
  textTransform: "uppercase",
  letterSpacing: 0,
};

export const segmentedButtonSx = {
  "& .MuiButton-root": {
    color: blue.border,
    borderColor: blue.border,
    backgroundColor: "#fff",
    fontWeight: 700,
    "&:hover": {
      color: blue.dark,
      borderColor: blue.dark,
      backgroundColor: blue.soft,
    },
    "&.MuiButton-contained": {
      color: blue.dark,
      borderColor: blue.main,
      backgroundColor: "#fff",
      boxShadow: `inset 0 0 0 1px ${blue.main}`,
      "&:hover": {
        color: blue.dark,
        borderColor: blue.dark,
        backgroundColor: "#fff",
        boxShadow: `inset 0 0 0 1px ${blue.dark}`,
      },
    },
    "&.Mui-disabled": disabledButtonSx["&.Mui-disabled"],
  },
};
